import React from 'react';
import { useRouter } from 'next/router';
import { Card, Table } from '@avila-tek/ui/src';
import { createColumnHelper } from '@tanstack/react-table';
import { PageInfo, Pagination, Plan } from '../../models';
import { ActiveDotCell } from '../shared';

const columnHelper = createColumnHelper<Plan>();

const columns = [
  columnHelper.accessor('title', {
    header: 'Nombre',
  }),

  columnHelper.accessor('active', {
    header: 'Estatus',
    cell: (info) => <ActiveDotCell active={info?.getValue()} />,
  }),
];

interface PlanTableProps {
  data: Pagination<Plan>;
  pagination: Partial<PageInfo>;
  setPagination: React.Dispatch<React.SetStateAction<Partial<PageInfo>>>;
}

function PlanTable({ data, pagination, setPagination }: PlanTableProps) {
  const router = useRouter();

  const onClickRow = (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
    e.preventDefault();
    const { id } = e.currentTarget.dataset;
    router.push(`/app/maintenance/plans/${id}`);
  };

  const onClickAddButton = () => router.push('/app/maintenance/plans/create');

  const handleGoToPage = (value: number) => {
    setPagination({ ...pagination, currentPage: value });
  };

  return (
    <Card className="overflow-x-auto p-5">
      <Table<Plan>
        data={data.items}
        columns={columns}
        href="/app/maintenance/sales/create"
        manualPagination
      >
        <Table.Header>
          <Table.SearchInput />
          <Table.AddButton title="Plan" action={onClickAddButton} />
        </Table.Header>
        <Table.Content<Plan> onClickRow={onClickRow} />
        <Table.Footer>
          <Table.Pagination
            handleGoToPage={handleGoToPage}
            paginationInfo={{
              count: data.count,
              pageInfo: { ...data.pageInfo },
            }}
            className="ml-auto"
          />
        </Table.Footer>
      </Table>
    </Card>
  );
}

export default PlanTable;
